import { BOSS_MAX_HP } from './corePhases';
import { coreColorCss, getCoreAppearance } from './coreAppearance';
import './CanvasHealthBars.css';
import CoreHealthFill, { CoreShieldValue } from './CoreHealthFill';

const CanvasHealthBars = ({
  boss,
  bossReadoutRef,
  bossStatus,
  reduceMotion,
}) => {
  const appearance = boss && getCoreAppearance(boss.phase);
  return (
    <>
      {boss && (
        <section
          ref={bossReadoutRef}
          className="coreboundCanvasBossHealth"
          role="group"
          aria-label="Glitch Core on the board"
          style={{ '--boss-health-color': coreColorCss(appearance.light) }}
        >
          <div className="coreboundCanvasBossHealthHeading">
            <div>
              <span>FINAL ENCOUNTER · {appearance.name}</span>
              <strong>THE GLITCH CORE</strong>
            </div>
            <span className="coreboundCanvasHealthValue">
              {boss.hp} <small>/ {BOSS_MAX_HP} HP</small>
              <CoreShieldValue shield={boss.shield} />
            </span>
          </div>
          <div
            className="coreboundCanvasHealthTrack"
            role="progressbar"
            aria-label="Glitch Core board HP"
            aria-valuemin={0}
            aria-valuemax={BOSS_MAX_HP}
            aria-valuenow={boss.hp}
          >
            <CoreHealthFill
              hp={boss.hp}
              shield={boss.shield}
              reduceMotion={reduceMotion}
            />
          </div>
          {bossStatus}
        </section>
      )}
    </>
  );
};

export default CanvasHealthBars;
